import requests from "./httpService";
// import Cookies from 'js-cookie';
//  const adminInfo= localStorage.getItem("adminInfo")
//     ? JSON.parse(localStorage.getItem("adminInfo"))
//     : null;
// const id_employee = (adminInfo?.id) ? adminInfo.id : 0;

const FixedItineraryServices = {
  getAllFixedItinerary: async (body) => {
    return requests.get(`/fixedItinerary/`);
  },

  getAllPackage: async (body) => {
    return requests.get(`/fixedItinerary/packagecode/`);
  },

  addFixedItinerary: async (body) => {
    return requests.post(`/fixedItinerary/add/`, body);
  },

  getFixedItineraryById: async (id) => {
    return requests.get(`/fixedItinerary/${id}`);
  },

  updateFixedItinerary: async (id, body) => {
    return requests.put(`/fixedItinerary/update/${id}`, body);
  },

  deleteFixedItinerary: async (id) => {
    return requests.delete(`/fixedItinerary/delete/${id}`);
  },

  exportExcel: async (id, body) => {
    return requests.get(`/fixedItinerary/exportExcel/`, body);
  },

  checkPackage: async (body) => {
    return requests.post(`/fixeditinerary/checkPackageCode/`, body);
  },

    updatefixedItineraryStatus: async (id, body) => {
        return requests.post(`/fixedItinerary/update-status/${id}`, body);
      }
};

export default FixedItineraryServices;
